import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-background flex items-center justify-center p-6">
          <div className="bg-card rounded-2xl p-6 border border-destructive/30 max-w-lg w-full space-y-4">
            <h2 className="text-lg font-bold text-destructive">Algo deu errado</h2>
            <p className="text-sm text-muted-foreground">
              {this.state.error?.message}
            </p>
            <pre className="text-xs text-muted-foreground bg-muted rounded-lg p-3 overflow-auto max-h-[60vh] whitespace-pre-wrap break-all">
              {this.state.error?.stack}
            </pre>
            <button
              onClick={() => {
                this.setState({ hasError: false, error: null });
              }}
              className="bg-primary text-primary-foreground px-4 py-2 rounded-lg text-sm font-medium"
            >
              Tentar novamente
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
